import { render, staticRenderFns } from "./WaiverAdminForm.vue?vue&type=template&id=1384b9c2&"
import script from "./WaiverAdminForm.vue?vue&type=script&lang=js&"
export * from "./WaiverAdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports